import React from 'react'
import { Text } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'

import {
    ClientFieldsFragment,
    PatientFieldsFragment,
    AppointmentFieldsFragment,
} from '~graphql/generated/graphql'
import StepHeader from '../step-header'
import SuggestedPatients from './suggested-patients'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface Props {
    appointment: AppointmentFieldsFragment
    isMissingClient: boolean
    client: ClientFieldsFragment | undefined
    patient: PatientFieldsFragment | undefined
    setPatient: (patient: PatientFieldsFragment | undefined) => void
    isMakingNewClient: boolean
    isMakingNewPatient: boolean
    setIsMakingNewPatient: (isMakingNewPatient: boolean) => void
}

export default function PatientSelect({
    appointment,
    isMissingClient,
    client,
    patient,
    setPatient,
    isMakingNewClient,
    isMakingNewPatient,
    setIsMakingNewPatient,
}: Props) {
    const { patient_info } = appointment

    if (!patient_info) {
        return <>No patient info found on linked appointment</>
    }

    return (
        <SharedStack spacing={4}>
            <StepHeader
                number={isMissingClient ? 2 : undefined}
                label="Select a patient"
                isCompleted={
                    !!patient || isMakingNewPatient || isMakingNewClient
                }
                isDisabled={!client}
                alternateAction={
                    <Text>
                        {'('}or{' '}
                        <Button
                            as="span"
                            cursor="pointer"
                            variant="link"
                            colorScheme="brand"
                            onClick={() => setIsMakingNewPatient(true)}
                        >
                            Create a new one
                        </Button>
                        {')'}
                    </Text>
                }
            />
            {!!client && !patient && !isMakingNewPatient && (
                <SuggestedPatients
                    client={client}
                    patientInfo={patient_info}
                    setPatient={setPatient}
                />
            )}
        </SharedStack>
    )
}
